import React from "react";
import AJTI from "../../Assets/Photos/client-logo/ajti-brand-logo.jpeg";
import AG from "../../Assets/Photos/client-logo/aluminum.png";
import GB from "../../Assets/Photos/client-logo/gab-builder.png";

const clients = [
  {
    name: "Aluminum Glass & UPVC Work",
    logo: AG,
  },
  {
    name: "Gab Builder",
    logo: GB,
  },
  {
    name: "GiftShare Japan",
    logo: AJTI,
  },
  {
    name: "Sultana Boutique",
    logo: AJTI,
  },
  {
    name: "Ajharna Trade Int.",
    logo: AJTI,
  },

  {
    name: "Zahrani Construction",
    logo: AJTI,
  },
];

const OurClients = () => {
  return (
    <section className="pb-10 pt-5 bg-base-100">
      <div className="mx-auto max-w-6xl px-5 lg:p-0">
        <div className="text-center">
          <div className="divider text-xl py-5">
            <h1 className="mx-auto text-4xl font-bold my-3">Our Clients</h1>
          </div>
        </div>

        <div className="relative w-full overflow-hidden text-gray-400">
          <div className="flex gap-x-10 gap-y-4 animate-marquee whitespace-nowrap">
            {clients.map((client, index) => (
              <div
                key={index}
                className="flex flex-col items-center transition"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className=" h-16 rounded-sm mb-2"
                />
                <p className="text-center">{client.name}</p>
              </div>
            ))}
            {/* Duplicate for infinite scroll */}
            {clients.map((client, index) => (
              <div
                key={`duplicate-${index}`}
                className="flex flex-col items-center transition"
              >
                <img
                  src={client.logo}
                  alt={client.name}
                  className="h-16 rounded-sm mb-2"
                />
                <p className="text-center">{client.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurClients;
